module.exports = __webpack_public_path__ + "media/honey-icons/icon-pause-ba8e0f8c.svg";